<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <!-- <app-header></app-header> -->
    <div class="site-content-wrap position-relative">
       <!--  Start Sign Up Final Steup Verification Screen -->

        <section class="section-wrap pb-5 position-relative" >
            <div class="login-top-box">
                <div class="login-cover-img imgvid-cover" *ngIf="usertYpes==2">
                    <img loading="lazy" src="../../../assets/images/organisation_signup_bg.jpg">
                </div>
                <div class="login-cover-img imgvid-cover" *ngIf="usertYpes==3">
                    <img loading="lazy" src="../../../assets/images/creator_signup_bg.png">
                </div>   
                <div class="login-cover-img imgvid-cover" *ngIf="usertYpes==1">
                    <img  loading="lazy"  src="../../../assets/images/signin_bg.jpg">
                </div>
            </div>
            <div class="login-content-wrap">
                <div class="container">
                    <div class="row align-items-center justify-content-center pb-5">
                        <div class="col-12 col-sm-10 col-md-10 col-lg-5 pb-4 pb-sm-0" *ngIf="currentUrl =='/verify-email'">
                            <div class="login-signupbox p-3  overflow-hidden">
                                <div class="verify-header pb-3 pt-4 text-center">
                                    <div class="py-4">
                                        <img loading="lazy" src="../../../assets/images/inner_logo.png">
                                    </div>

                                    <h5 class="title white-color font-w-normal pb-2" ><span [translate]="'GREATER.YOUR_EMAIL_HAS_BEEN_VERIFIED'"> </span>  </h5>

                                    <h3 class="title white-color pb-2"><span [translate]="'GREATER.NICE_WORK'"> </span>  </h3>
                                    <div class="pb-3 pt-3">
                                        <img  loading="lazy"  src="../../../assets/images/verified_ic.png">
                                    </div>
                                    <div class="row align-items-center justify-content-center">
                                        <div class="col-12 col-md-10">
                                             <div class="pb-4">
                                                <span class="white-color" >Let's start by uploading your profile photo.  </span>
                                            </div>
                                            <div class="pb-1">
                                                <span class="white-color" >Once that's done, please complete:  </span>
                                            </div>
                                            <div class="pb-4">
                                                <span class="white-color" > Overview | Bank Account | Subscriptions </span>
                                            </div>
                                       
                                        </div>
                                    </div>
                                  
                                    <div class="pt-4" >
                                        <a  routerLink="/edit-profile" class="btn brandpurpal-btn custom-btn"><span [translate]="'GREATER.UPLOAD_PHOTO'"> </span> </a>
                                    </div>
                                 
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-10 col-md-8 col-lg-5 pb-4 pb-sm-0" *ngIf="currentUrl !='/failed-account-verification' && currentUrl !='/verify-email' && verificationSuccess">
                            <div class="login-signupbox p-3 p-sm-5 overflow-hidden">
                                <div class="verify-header pb-3 pt-4 text-center">
                                    <div class="pb-5">
                                        <img  loading="lazy"  src="../../../assets/images/verified_ic.png">
                                    </div>
                                    <h3 class="title white-color pb-2"><span [translate]="'GREATER.NICE_WORK'"> </span>  </h3>
                                    <h5 class="title white-color font-w-normal pb-2"  *ngIf="currentUrl =='/success-account-verification' || currentUrl =='/confirmation-account-verification'"><span [translate]="'GREATER.BANK_ACCOUNT_LINK_SUCCESSFULLY'"> </span>  </h5>

                                    <h5 class="title white-color font-w-normal pb-2" *ngIf="currentUrl =='/verify-email' || currentUrl == '/verify-email-mobile'"><span [translate]="'GREATER.YOUR_EMAIL_HAS_BEEN_VERIFIED'"> </span>  </h5>
                                    <div class="row align-items-center justify-content-center" *ngIf="currentUrl =='/verify-email' || currentUrl == '/verify-email-mobile'">
                                        <div class="col-12 col-md-8 col-lg-8">
                                            <p class="grey-color m-0"> <span [translate]="'GREATER.NOW_LET_SETUP_YOUR_PROFILE_UPLOAD_CONTENT'"> </span> </p>
                                        </div>
                                    </div>
                                    <!-- <div class="row align-items-center justify-content-center" *ngIf="currentUrl =='/success-account-verification'">
                                        <div class="col-12 col-md-8 col-lg-8">
                                            <p class="grey-color m-0"> You're now ready to upload and publish content. </p>
                                        </div>
                                    </div> -->
                                    <div class="pt-4" *ngIf="currentUrl =='/verify-email'">
                                        <a  routerLink="/edit-profile" class="btn gradient1-btn custom-btn"><span [translate]="'GREATER.COMPLETE_MY_PROFILE'"> </span> </a>
                                    </div>
                                    <div class="pt-4" *ngIf="currentUrl =='/success-account-verification' || currentUrl =='/confirmation-account-verification'">
                                        <a  routerLink="/edit-profile" class="btn gradient1-btn custom-btn"><span [translate]="'GREATER.CONTINUE'"> </span> </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-10 col-md-8 col-lg-5 pb-4 pb-sm-0" *ngIf="currentUrl =='/failed-account-verification'">
                            <div class="login-signupbox p-3 p-sm-5 overflow-hidden">
                                <div class="verify-header pb-3 pt-4 text-center">
                                    <div class="pb-5">
                                        <img loading="lazy" src="../../../assets/images/inner_logo.png">
                                    </div>
                                    <h5 class="title white-color font-w-normal pb-2"  >Trouble In Paradise     <span class="ps-3 tooltip-btn"  matTooltip=".">
                                        <i class="gricon gr_ic_info"></i>
                                    </span> </h5>

                                    <div class="row align-items-center justify-content-center" >
                                        <div class="col-12 ">
                                            <p class="white-color m-0 mb-1"> We aren't able to connect with your Stripe account. </p>
                                            <p class="white-color m-0 mb-1"> Please try again or contact Stripe for support. </p>
                                            <p class="white-color m-0 mb-1"><a  href="https://support.stripe.com/contact/login" target="_blank"> https://support.stripe.com/contact/login </a></p>
                                            <p class="white-color m-0 mb-1"> If you need further support reach us via the  <a routerLink="/faq" href="javascript:void(0)"> FAQ</a>. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <app-footer></app-footer>
</main>
